import { Box } from '@chakra-ui/react';
import InfiniteScroll from 'react-infinite-scroll-component';

import { Condition, Iteration } from 'Component/others';
import useGetTaskHistory from 'Domain/host-presence-content/useGetTaskHistory';
import CardReportContent from 'View/host-presence-content/components/card-report-content';
import EmptyState from 'Component/empty-state';
import ListPresenceContentSkeleton from 'View/host-presence-content/components/skeleton/list-presence-content';
import { useHostPresenceContentState } from 'View/host-presence-content/state';

import styles from './styles.module.css';

const ListReportContent = () => {
  const { updateFilterState, filterState } = useHostPresenceContentState();

  const { data: taskListData, isFetching: isLoadingTaskList } = useGetTaskHistory({ params: filterState });

  const hasMoreData = taskListData?.currentPage < taskListData?.totalPage;
  const hasData = taskListData?.tasks?.length > 0;
  const isInitialLoading = isLoadingTaskList && filterState.page === 1;

  const onLoadMore = () => {
    updateFilterState({ page: filterState.page + 1 });
  };
  return (
    <InfiniteScroll dataLength={taskListData?.tasks?.length ?? 0} hasMore={hasMoreData} next={onLoadMore} scrollThreshold="90%">
      <Box className={styles['list-report-content__container']}>
        <Condition statement={!isInitialLoading} fallback={<ListPresenceContentSkeleton />}>
          <Condition statement={hasData} fallback={<EmptyState />}>
            <Iteration items={taskListData?.tasks} render={(item, index) => <CardReportContent key={index} data={item} />} />
          </Condition>
        </Condition>
      </Box>
    </InfiniteScroll>
  );
};

export default ListReportContent;
